import React, { Component} from 'react'
import MQTDisplayOption1 from './MQTDisplayOption1';
import MQTDisplayOption2 from './MQTDisplayOption2';

export default class MQTQuestion extends Component {
    constructor(props){
        super(props);
        this.state = {
            question_answer_map:{}
        }
    }
    
    UNSAFE_componentWillReceiveProps(nextProps){
        const {showMQTAnswers} = nextProps;
        if(showMQTAnswers === true){
            const {mqt_question_answer_map} = nextProps.mqt_options;
            this.setState({question_answer_map:mqt_question_answer_map});
        }
        else{
            if(nextProps.questionID !== this.props.questionID || nextProps.count !== this.props.count){
                this.setState({question_answer_map:{}});
            }
        }
        
    }

    componentDidMount() {
        if (this.props.selectedAnswers) {
            this.setState({
                question_answer_map: this.props.selectedAnswers,
            })
        }
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.question_attempt !== this.props.question_attempt) {
            this.setState({
                question_answer_map: {},
            })
        }
        if (prevProps.alreadyPickedAnswer !== this.props.alreadyPickedAnswer) {
            this.setState({
                question_answer_map: this.props.selectedAnswers,
            })
        }
    }
    onAnswerChoice = (checked,value) => {
        

        //WHen Check Answer is enabled, disable all events
        if(this.props.showMQTAnswers)
            return;
        
        let question_answer_map = this.state.question_answer_map;
        const {mqt_answer_type} = this.props.mqt_options;

        if(mqt_answer_type){
            if(mqt_answer_type === 'checkbox'){
                if(!question_answer_map[value.qID]){
                    question_answer_map[value.qID] = [];
                }
        
                if(checked)
                {
                
                    let index = question_answer_map[value.qID].indexOf(value.aID);
                    if(index === -1){
                        question_answer_map[value.qID].push(value.aID);
                    }
                   
                    
                }else{
                    
                    let index = question_answer_map[value.qID].indexOf(value.aID);
                    
                    
                    if(index !== -1){
                        let answer_array = question_answer_map[value.qID].slice();
                        answer_array?.splice(index,1);
                        question_answer_map[value.qID] = answer_array;
                    }
                    
                    
                }
            }else{
                question_answer_map[value.qID] = [];
                question_answer_map[value.qID].push(value.aID);
            }
        }
        
        
        this.setState({question_answer_map});
        this.props.onAnswerChoice(question_answer_map);
    }

    render(){
        
        const {mqt_questions,mqt_answers,mqt_answer_count, mqt_question_random_order, mqt_answers_random_order, mqt_answer_header,mqt_answer_type,mqt_hide_question} = this.props.mqt_options;
        console.debug("mqt_answer_header", mqt_answer_header)
        if(mqt_answer_header)
        {
            return <MQTDisplayOption2 question_answer_map={this.state.question_answer_map} random_answer_order={mqt_answers_random_order} random_order={mqt_question_random_order} type={mqt_answer_type} questionID={this.props.questionID} onAnswerChoice={this.onAnswerChoice} mqt_questions={mqt_questions} mqt_answers={mqt_answers} mqt_hide_question={mqt_hide_question}
            showAnswerResponse={this.props.showAnswerResponse}
            answerCorrect={this.props.answerCorrect}
            showSubmitLoader={this.props.showSubmitLoader}
            question_attempt={this.props.question_attempt}
            ></MQTDisplayOption2>
        }else{
            return <MQTDisplayOption1 question_answer_map={this.state.question_answer_map} random_answer_order={mqt_answers_random_order} random_order={mqt_question_random_order} type={mqt_answer_type} questionID={this.props.questionID} onAnswerChoice={this.onAnswerChoice} mqt_questions={mqt_questions} mqt_answer_count={mqt_answer_count}
            showAnswerResponse={this.props.showAnswerResponse}
            answerCorrect={this.props.answerCorrect}
            showSubmitLoader={this.props.showSubmitLoader}
            question_attempt={this.props.question_attempt}
            ></MQTDisplayOption1>
        }   
            
    }
}